import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/Designer.jpeg";
import logoIcn from "assets/images/LOGO-Icontec-2019_ver_white.png";

const cookies = new Cookies();

function Basic() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        "https://contratosback.azurewebsites.net/api/v1/AutenticaFormulario",
        {
          correo: email,
          contrasena: password,
        }
      );

      const respuesta = response.data[0];
      cookies.set("id", respuesta.id, { path: "/" });
      cookies.set("correo", respuesta.correo, { path: "/" });
      cookies.set("tipo_Usuario", respuesta.tipoUsuarioId, { path: "/" });

      Swal.fire({
        icon: "success",
        title: `Bienvenido`,
        text: `${respuesta.correo}`,
        timer: 2000,
        showConfirmButton: false,
      });

      navigate("/SolicitudesPropias/");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error de inicio de sesión",
        text: "Verifica tus credenciales.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <img
            src={logoIcn}
            alt="Logo"
            style={{ width: "100px", height: "80px", marginBottom: "10px" }}
          />
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            <p>Mesa de servicios Jurídica</p>
          </MDTypography>
        </MDBox>
        <center>
          <MDTypography variant="h4" fontWeight="medium" color="blue" mt={1}>
            <p>Inicio de sesión</p>
          </MDTypography>
        </center>

        <div className="text-center">
          <a
            href="https://contratosback.azurewebsites.net/api/v1/AuthAzureLegal"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "7px",
              backgroundColor: "#0b0101ff",
              color: "white",
              padding: "15px 14px",
              borderRadius: "8px",
              textDecoration: "none",
              fontSize: "12px",
              fontWeight: "bold",
              boxShadow: "0px 4px 8px rgba(238, 236, 236, 0.3)",
              transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0px 6px 12px rgba(227, 227, 227, 0.4)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0px 4px 8px rgba(241, 241, 241, 0.3)";
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
              alt="Microsoft"
              style={{ width: "24px", height: "24px" }}
            />
            Iniciar sesión con correo corporativo <br></br>ICONTEC
          </a>
        </div>
        <br></br>
        {/** 
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
                {loading ? "Cargando..." : "Acceder"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
        */}
      </Card>
    </BasicLayout>
  );
}

export default Basic;
